import { useMutation } from "react-query";
import { CORE_API_SUFFIX, dataFetch } from "../../../axios/customAxios";
import { ApiError, ApiResponse } from "../../../interfaces/apiResponse.type";
import closableEnqueueSnackbar from "../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar";
import {useTranslation} from "react-i18next";
import {handleApiError} from "../../requestHelpers/requestHelpers";

export const sendUploadFile = (refetch: any) => {
    const { t } = useTranslation();

    return useMutation<ApiResponse<null>, ApiError<null>, FormData>(
        (formData) =>
            dataFetch.post(`${CORE_API_SUFFIX}ad/import`, formData , {
                headers: { "Content-Type": "multipart/form-data" },
            }),
        {
            onSuccess: ({ data }) => {
                refetch();
                closableEnqueueSnackbar(t('fileUploadedSuccess'), 'success');
            },
            onError: (error: any) => {
                refetch();
                handleApiError(error, t);
            },
        }
    );}
